import React from 'react';

const ServicesSection = () => {
  const services = [
    {
      title: 'Educación Digital',
      description:
        'Plataforma de cursos virtuales donde puedes aprender a tu ritmo, desde cualquier lugar, y obtener certificados digitales. También puedes crear tus propios cursos y ganar dinero compartiendo lo que sabes.',
      image: '/img/servicios/Educación Digital.jpg',
    },
    {
      title: 'Marketing Digital',
      description:
        'Plataforma con estrategias para posicionar tu marca en el mundo digital. Donde trabajaremos contigo para ayudarte a llevar tu negocio al próximo nivel, dando visibilidad real en internet con herramientas como directorio de servicios, publicidad y manejo digital para que más personas encuentren tu negocio.',
      image: '/img/servicios/Marketing Digital.jpg',
    },
    {
      title: 'Soluciones Turísticas',
      description:
        'Tecnología para potenciar la experiencia de viaje.',
      image: '/img/servicios/turismo.jpg',
    },
    {
      title: 'E-commerce',
      description:
        'Plataforma de compra y venta que impulsa la economía circular al conectar personas que quieren vender y/o comprar productos nuevos y usados.',
      image: '/img/servicios/Comercio electrónico.jpg',
    },
    {
      title: 'Diseño Web',
      description:
        'Creamos tu página web profesional, adaptada a tu negocio y lista para compartir. Ideal para mejorar tu presencia online y conectar con más clientes.',
      image: '/img/servicios/Diseño Web.jpg',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        {/* Encabezado con fondo azul */}
        <div className="text-center mb-16 bg-[#007dc6] py-10 rounded-xl">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Nuestros Servicios
          </h2>
          <p className="text-white max-w-2xl mx-auto">
            Ofrecemos soluciones tecnológicas integrales para impulsar tu negocio en el mundo digital.
          </p>
        </div>

        {/* Tarjetas de servicios */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 flex flex-col items-center text-center hover:shadow-2xl transition duration-300"
            >
              <div className="w-full h-52 md:h-64 mb-6">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover rounded-xl shadow-md"
                />
              </div>
              <h3 className="text-xl font-bold text-[#007dc6] mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 text-sm md:text-base">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
